import script from "./personRemark.vue?vue&type=script&setup=true&name=PersonRemark&lang=js"
export * from "./personRemark.vue?vue&type=script&setup=true&name=PersonRemark&lang=js"

import "./personRemark.vue?vue&type=style&index=0&id=5ce63f34&scoped=true&lang=css"
import "./personRemark.vue?vue&type=style&index=1&id=5ce63f34&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce63f34"]])

export default __exports__